import { ITab } from 'shared/components/buttons/tab-button/tab-button-interface';

export enum VehicleChecksTab {
  CHECKS = 'checks',
  DAMAGE_REPORTS = 'damage-reports',
}

export const vehicleChecksTabs: ITab[] = [
  {
    label: 'Checks',
    key: VehicleChecksTab.CHECKS,
  },
  {
    label: 'Damage Reports',
    key: VehicleChecksTab.DAMAGE_REPORTS,
  },
];
